import { HomeCareLeadId } from "@sp-crm/core";
import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { useCallback } from "react";

export function useInvalidateHomeCareLead(homeCareLeadId: HomeCareLeadId): () => void {
    const queryClient = useQueryClient();
    const trpcContext = trpc.useTRPC();
    return useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: trpcContext.homeCareLead.get.queryKey({ id: homeCareLeadId }),
        });
        queryClient.invalidateQueries({
            queryKey: trpcContext.homeCareLeadContact.list.queryKey({ homeCareLeadId }),
        });
        queryClient.invalidateQueries({
            queryKey: trpcContext.homeCareLeadPartnerSend.sends.queryKey({
                homeCareLeadId,
            }),
        });
    }, [queryClient, trpcContext, homeCareLeadId]);
}
